<app-rideaddform></app-rideaddform>
<app-rideslist [rides]="rides"></app-rideslist>